export default "__VITE_ASSET__DiAbmsOY__"